var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77783 10.7664C2.77783 6.35443 6.35443 2.77783 10.7664 2.77783C15.1784 2.77783 18.755 6.35443 18.755 10.7664C18.755 15.1784 15.1784 18.755 10.7664 18.755C6.35443 18.755 2.77783 15.1784 2.77783 10.7664ZM10.7664 0.777832C5.24986 0.777832 0.777832 5.24986 0.777832 10.7664C0.777832 16.2829 5.24986 20.755 10.7664 20.755C13.0454 20.755 15.1462 19.9917 16.827 18.7069L19.8359 21.708C20.2269 22.098 20.8601 22.0972 21.2501 21.7061C21.6401 21.3151 21.6393 20.6819 21.2483 20.2919L18.2879 17.3392C19.8241 15.5827 20.755 13.2832 20.755 10.7664C20.755 5.24986 16.2829 0.777832 10.7664 0.777832Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlack);
export default __webpack_public_path__ + "static/media/icon-search-black.06fda6b17385337cd0baba8c4472c5f8.svg";
export { ForwardRef as ReactComponent };